<form [formGroup]="informationForm">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h6 class="text-center routeEditGroupTitle mb-2">{{'BASIC_INFORMATION' | translate}}</h6>
      </div>
    </div>
    <div class="row p-3 card card-borders">
      <div>
        <mat-form-field class="full-width">
          <input matInput placeholder="{{'ALARM_ROUTE_NAME' | translate}}" formControlName="alarmRoutingName"
            required autofocus>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="full-width">
            <mat-label>{{'LOCATION' |translate}}</mat-label>
            <mat-select formControlName="locationId">
              @for (location of alarmRouteLocations; track location) {
                <mat-option [value]="location.locationId">
                  {{location.locationName}} ({{location.locationId}})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="full-width">
            <mat-label>{{'PRIORITY' |translate}}</mat-label>
            <mat-select formControlName="priority">
              @for (priority of priorityList; track priority) {
                <mat-option [value]="priority">
                  {{'PRIORITY_' + priority | translate}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="full-width">
            <mat-label>{{'DELIVERY_TYPE' |translate}}</mat-label>
            <mat-select formControlName="deliveryMethod">
              @for (group of deliveryMethodGroups; track group) {
                <mat-optgroup>
                  {{group.name | translate}}
                  @for (deliveryType of group.deliveryTypes; track deliveryType) {
                    <mat-option [value]="deliveryType">
                      {{deliveryType | translate}}
                    </mat-option>
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="additionalInformationBox">
          <mat-form-field appearance="fill">
            <mat-label>{{'ADDITIONAL_INFORMATION' | translate}}</mat-label>
            <textarea matInput formControlName="additionalInformation"></textarea>
          </mat-form-field>
        </div>
        @if (!tempRoute.defaultRoute) {
          <h5 (click)="showAdvancedSettings = !showAdvancedSettings"
            class="cursorPointer advancedSettings mb-5">{{'ADDITIONAL_SETTINGS' |translate}}
            <span class="fa-light advancedSettings"
            [ngClass]="showAdvancedSettings ? 'fa-chevron-down' : 'fa-chevron-up'"></span>
          </h5>
        }
        @if (showAdvancedSettings) {
          @if (tempRoute.deliveryType.includes('CALL')) {
            <div class="mb-4 mt-2">
              @if (tempRoute.callLoopFailType !== 'NONE') {
                <p>
                  <span class="fa-solid fa-fw fa-triangle-exclamation"></span> {{'CALL_LOOP_FAIL_TYPE_INFO'
                  |translate}} <span class="fa-solid fa-fw fa-triangle-exclamation"></span>
                </p>
              }
              <mat-form-field class="full-width">
                <mat-label>{{'CALL_LOOP_FAIL_TYPE' |translate}}</mat-label>
                <mat-select formControlName="callLoopFailType">
                  <mat-option [value]="'NONE'">--</mat-option>
                  <mat-option [value]="'LOG'">{{'LOG' |translate}}</mat-option>
                  <mat-option [value]="'EMAIL'">{{'EMAIL' |translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (emaFeatureEnabled()) {
            <div class="mb-4 mt-2">
              <mat-slide-toggle formControlName="skipInactiveTeamsForAssistance">
                {{'SKIP_INACTIVE_TEAMS_FOR_ASSISTANCE' |translate}}
              </mat-slide-toggle>
              <span matTooltip="{{'KEEP_ASSISTANCE_ALARMS_WITHIN_ACTIVE_TEAM' |translate}}"
              class="fa-solid fa-circle-info ml-2"></span>
            </div>
          }
          @if (!tempRoute.defaultRoute) {
            <div>
              <mat-form-field class="full-width">
                <mat-label>{{'CALL_CENTER' |translate}}</mat-label>
                <mat-select formControlName="callCenterId">
                  <mat-option [value]="''">--</mat-option>
                  @for (callCenter of callCenters; track callCenter) {
                    <mat-option [value]="callCenter.id">
                      {{callCenter.name}} ({{callCenter.id}})
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (tempRoute.callCenterId !== '') {
            <div>
              <mat-form-field class="full-width">
                <mat-label>{{'CALL_CENTER_DELIVERYTYPE' |translate}}</mat-label>
                <mat-select formControlName="callCenterDeliverytype">
                  @for (deliveryType of callCenterDeliveryTypeTranslationsMap | keyvalue; track deliveryType) {
                    <mat-option
                      [value]="deliveryType.key">
                      {{deliveryType.value | translate}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @if (tempRoute.deliveryType !== 'EMAIL' && tempRoute.deliveryType !== 'LOG' && emaFeatureEnabled() ) {
            @if (!tempRoute.defaultRoute) {
              <div>
                <mat-form-field class="full-width">
                  <mat-label>{{'FALLBACK_DELIVERY_TYPE' |translate}}</mat-label>
                  <mat-select formControlName="fallbackDeliveryMethod">
                    <mat-option [value]="'NONE'">--</mat-option>
                    @for (group of deliveryMethodGroups; track group) {
                      <mat-optgroup>
                        {{group.name | translate}}
                        @for (deliveryType of group.deliveryTypes; track deliveryType) {
                          <mat-option [value]="deliveryType">
                            {{deliveryType | translate}}
                          </mat-option>
                        }
                      </mat-optgroup>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            }
            @if (!tempRoute.defaultRoute && tempRoute.fallBackType !== 'LOG' && tempRoute.fallBackType !== 'EMAIL' && tempRoute.fallBackType !== 'NONE') {
              <div
                >
                <mat-form-field class="full-width">
                  <mat-label>{{'FALLBACK_CALL_CENTER' |translate}}</mat-label>
                  <mat-select formControlName="fallbackCallCenterId">
                    <mat-option [value]="'NONE'">--</mat-option>
                    <mat-option [value]="'VERIFI'">EMAAC</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            }
          }
          @if (!tempRoute.defaultRoute) {
            <div class="mb-4 mt-2">
              <mat-slide-toggle formControlName="alarmIndicationGroupEnabled">
                {{'ALARM_INDICATION_GROUP' |translate}}
              </mat-slide-toggle>
            </div>
          }
          @if (false) {
            <div class="mb-4">
              <mat-slide-toggle formControlName="waitForSmsAcknowledgement">
                {{'WAIT_FOR_SMS_ACKNOWLEDGEMENT' |translate}}
              </mat-slide-toggle>
            </div>
          }
        }
      </div>
    </div>
  </form>
